import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { map, take, finalize } from 'rxjs/operators';
import { FaqModel } from '../../models/faq-model';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;
  faqs: FaqModel[] = [];
  subscription: Subscription;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.getFaqs();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  get(route: string) {
    return this.http.get(route).pipe(map((response: any) => response));
  }

  getFaqs() {
    this.isLoading = true;
    this.subscription = this.get('./assets/json/faq.json')
      .pipe(take(1), finalize(() => this.isLoading = false))
      .subscribe(
        (res: FaqModel[]) => {
          this.faqs = res;
        },
        error => {
          console.log(error);
        }
      );
  }
}
